import { all, path } from 'ramda';
import { createSelector } from 'reselect';
import { extractFilterIds } from '../../selectors';

export const areShopFiltersFetched = path(['reports', 'shopFilters', 'isFetched']);
export const getShopFilters = path(['reports', 'shopFilters', 'filters']);

export const getActiveShopIds = createSelector(
  getShopFilters,
  extractFilterIds
);

export const getShopFilterAllChecked = createSelector(
  getShopFilters,
  all(item => item.checked),
);

export const getShopFilterForApi = createSelector(
  getShopFilterAllChecked,
  getActiveShopIds,
  (isAllSelected, activeIds) => (isAllSelected ? [] : activeIds)
);
